'use client'

import { useCheckout, useModals } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { FuturePaymentDate } from '@/components/forms'

interface FuturePaymentDateModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const FuturePaymentDateModal = ({
  open,
}: FuturePaymentDateModalProps) => {
  const { closeModal, closeAll } = useModals()
  const { payment_method } = useCheckout()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('FUTURE_PAYMENT_DATE')}
        size="lg"
      >
        <DialogHeader>
          <DialogTitle>Payment Date</DialogTitle>
          <DialogDescription>
            Enter the payment date for {payment_method?.name}
          </DialogDescription>
        </DialogHeader>

        {open && <FuturePaymentDate onClose={() => closeAll()} />}
      </DialogContent>
    </Dialog>
  )
}
